<template>
  <div>
     
    <b-modal 
    id="delete-task-modal"
    v-model="remove" 
    title="Delete Task"
    @ok="handleOk"

    >
        <b-container fluid>
          <Loading v-if="loading"/>
         
            Are you sure you want to delete the task <b>{{ task.TaskName }}</b> ?
        </b-container>
    </b-modal>
  </div>
</template>

<script>
import Loading from '../../Loading'
  export default {
   
    components:{
      Loading
    },
    props: {
      task: {
        type: Object
      },
          
    },
    data() {
      return {

          remove:false,
          loading:false,
         
      }
    },

    
    methods:{
      handleShow(){

          this.remove = !this.remove

      },
      
      handleOk(bvModalEvt){

        bvModalEvt.preventDefault()
        this.handleDelete()

      },
        
      handleDelete(){
         this.loading = true
         fetch(`${process.env.VUE_APP_APIURL}/attendance/task/${this.task.TaskID}`, 
            {
                method:'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                     'authorization':this.$store.state.token
                },
               
            })
            .then(response => response.json())
            .then(data => {   

                this.$store.dispatch("getTasks") 
                this.$emit('changeMsg', 'Task deleted')
               

                setTimeout(() => {   
                  this.loading=false
                  this.$bvModal.hide('delete-task-modal')
                 
                }, 2000);            
            })
            .catch(err => {
                setTimeout(() => {
                    this.loading=false
                    this.$emit('changeError', 'Something went wrong.')
                }, 2000);
            });

           


      }
    }
  }
</script>